import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
}

const eraValues = {
  narrow: ['Miladdan əvvəl', 'Miladi tarix'],
  abbreviated: ['Miladdan əvvəl', 'Miladi tarix'],
  wide: ['Miladdan əvvəl', 'Miladi tarix'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-ci rüb', '2-ci rüb', '3-cü rüb', '4-cü rüb'],
  wide: ['1-ci rüb', '2-ci rüb', '3-cü rüb', '4-cü rüb'],
};

const monthValues = {
  narrow: [
    'Yanvar',
    'Fevral',
    'Mart',
    'Aprel',
    'May',
    'İyun',
    'İyul',
    'Avqust',
    'Sentyabr',
    'Oktyabr',
    'Noyabr',
    'Dekabr',
  ],
  abbreviated: [
    'Yan',
    'Fev',
    'Mart',
    'Apr',
    'May',
    'İyun',
    'İyul',
    'Avq',
    'Sent',
    'Okt',
    'Noy',
    'Dek',
  ],
  wide: [
    'Yanvar',
    'Fevral',
    'Mart',
    'Aprel',
    'May',
    'İyun',
    'İyul',
    'Avqust',
    'Sentyabr',
    'Oktyabr',
    'Noyabr',
    'Dekabr',
  ],
};

const dayValues = {
  narrow: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
  short: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
  abbreviated: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
  wide: [
    'Bazar günü',
    'Bazar ertəsi',
    'Çərşənbə axşamı',
    'Çərşənbə',
    'Cümə axşamı',
    'Cümə',
    'Şənbə',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'gecəyarısı',
    noon: 'gündüz',
    morning: 'səhər',
    afternoon: 'günorta',
    evening: 'axşam',
    night: 'gecə',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'gecəyarısı',
    noon: 'gündüz',
    morning: 'səhər',
    afternoon: 'günorta',
    evening: 'axşam',
    night: 'gecə',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'gecəyarısı',
    noon: 'gündüz',
    morning: 'səhər',
    afternoon: 'günorta',
    evening: 'axşam',
    night: 'gecə',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
